import * as React from "react"

import { ICategory } from "shared/hubrise/models"

import CategoryAndChildren from "./CategoryAndChildren"

const ProductList = ({ rootCategories }: { rootCategories: ICategory[] }): JSX.Element => {
  return (
    <React.Fragment>
      {rootCategories.map((category) => (
        <CategoryAndChildren key={category.id} category={category} />
      ))}
    </React.Fragment>
  )
}

export default ProductList
